<template>
  <!-- ▼Main Container -->
  <div class="boss-print-content">
    <div class="boss-table-title pega-print-title">
      <div class="pega-ta-right">
        <span data-test="company-name">{{ entryCompanyName }}
          <br>
          <span>
            <span
              v-if="isDuplicatedEntries"
              class="boss-status-label pega-status-label pega-status-label-top-0"
              data-test="label-duplicated-entries"
            >重複応募
            </span>
            <span
              v-if="isSimpleEntryForm"
              class="boss-status-label pega-status-label pega-status-label-top-0"
              data-test="label-entry-form"
            >自己PR不要
            </span>
            <span data-test="header-info">応募者：{{ userName }}様</span>
          </span>
        </span>
      </div>
    </div>
    <div class="boss-layout boss-layout-gap-between">
      <div>
        <div class="boss-resume-sheet-title pega-resume-sheet-title">
          選考状況
        </div>
      </div>
    </div>
    <entry-print-selection
      :entry-id="Number($route.params.entryId)"
      :selections="selections"
    />
    <p>アプローチ状況</p>
    <approached-summary
      :approached-summaries="approachedSummaries"
      :is-print-preview="true"
    />
    <p>直近のスカウト文面</p>
    <div
      v-if="hasScoutMessage"
      class="boss-message-wrap"
    >
      <entry-message-history-scout
        :body="scoutMessage.body"
        :subject="scoutMessage.subject"
        :date="scoutMessage.date"
        :job="scoutMessage.job"
        :expiration-date="scoutMessage.expirationDate"
        :special-favors="scoutMessage.specialFavors"
      />
    </div>
    <span
      v-else
      class="pega-no-scout-label"
    >
      直近のスカウトなし
    </span>
    <p class="boss-page-break" />
    <entry-detail-resume
      v-if="loaded.isFetchResumeCompleted"
      :entry-id="Number($route.params.entryId)"
      :header-user-name="userName"
      :entry-company-name="entryCompanyName"
      :is-duplicated-entries="isDuplicatedEntries"
      :is-simple-entry-form="isSimpleEntryForm"
      :parent-resume="resume"
    />
    <p class="boss-page-break" />
    <entry-detail-career-resume
      :entry-id="Number($route.params.entryId)"
      :header-user-name="userName"
      :entry-company-name="entryCompanyName"
      :is-duplicated-entries="isDuplicatedEntries"
      :is-simple-entry-form="isSimpleEntryForm"
    />
  </div>
  <!-- ▲Main Container -->
</template>

<script>
import { mapActions } from 'vuex'
import EntryDetailResume from '@/components/organisms/EntryDetailResume'
import ApproachedSummary from '@/components/molecules/ApproachedSummary'
import EntryDetailCareerResume from '@/components/organisms/EntryDetailCareerResume'
import EntryMessageHistoryScout from '@/components/molecules/EntryMessageHistoryScout'
import EntryPrintSelection from '@/components/organisms/EntryPrintSelection'
import _ from 'lodash'

export default {
  components: {
    EntryDetailResume,
    ApproachedSummary,
    EntryDetailCareerResume,
    EntryMessageHistoryScout,
    EntryPrintSelection
  },
  data () {
    return {
      selections: [],
      scoutMessage: {},
      userName: '',
      entryCompanyName: '',
      resume: null,
      resumeUpdateDate: '',
      isDuplicatedEntries: false,
      isSimpleEntryForm: false,
      approachedSummaries: [],
      loaded: {
        isFetchSelectionsCompleted: false,
        isFetchScoutMessageCompleted: false,
        isFetchEntryCompleted: false,
        isFetchResumeCompleted: false,
        isFetchApproachedSummaryCompleted: false
      }
    }
  },
  computed: {
    hasScoutMessage () {
      return !_.isEmpty(this.scoutMessage)
    }
  },
  watch: {
    loaded: {
      async handler () {
        if (_.values(this.loaded).every(x => x)) {
          await this.$nextTick()
          window.print()
        }
      },
      deep: true
    }
  },
  created () {
    this.storeMaster('skills')
    this.storeMaster('specialFavors')
    this.fetchSelections()
    this.fetchScoutMessage()
    this.fetchEntry()
    this.fetchResume()
    this.fetchApproachedSummary()
  },
  methods: {
    fetchSelections () {
      this.$http.secured.get(`/entry/view/entries/${this.$route.params.entryId}/selection_phases`)
        .then(response => {
          this.$set(this, 'selections', response.data)
          this.$set(this.loaded, 'isFetchSelectionsCompleted', true)
        })
    },
    fetchScoutMessage () {
      return this.$http.secured.get(`/entry/view/entries/${this.$route.params.entryId}/history/scouts`)
        .then(response => {
          this.$set(this, 'scoutMessage', _.head(response.data) || {})
          this.$set(this.loaded, 'isFetchScoutMessageCompleted', true)
        })
    },
    fetchEntry () {
      this.$http.secured.get(`/entry/view/entries/${this.$route.params.entryId}`).then(response => {
        this.$set(this, 'userName', _(response.data).at(['user.lastname', 'user.firstname']).join(' '))
        this.$set(this, 'entryCompanyName', _.get(response.data, 'companyName', ''))
        this.$set(this, 'isDuplicatedEntries', _.get(response.data, 'isDuplicatedEntries', false))
        this.$set(this, 'isSimpleEntryForm', _.get(response.data, 'isSimpleEntryForm', ''))
        this.$set(this.loaded, 'isFetchEntryCompleted', true)
      })
    },
    fetchResume () {
      return this.$http.secured.get(`/entry/view/entries/${this.$route.params.entryId}/resume`).then(response => {
        this.$set(this, 'resume', response.data)
        this.$set(this, 'resumeUpdateDate', _.get(response.data, 'updatedDate'))
        this.$set(this.loaded, 'isFetchResumeCompleted', true)
      })
    },
    fetchApproachedSummary () {
      this.$http.secured.get(`/entry/view/entries/${this.$route.params.entryId}/approached_jobs`).then(response => {
        this.$set(this, 'approachedSummaries', response.data)
        this.$set(this.loaded, 'isFetchApproachedSummaryCompleted', true)
      })
    },
    ...mapActions([
      'storeMaster'
    ])
  }
}
</script>
